import { FC, useEffect, useState } from "react";
import "./ReservationCancelSuccessScreen.css";
import { useNavigate } from "react-router-dom";
import allSetAnimation from "../../assets/gif/all-set-screen-animation.gif";
import allSetStar from "../../assets/images/all-set-screen-red-star.svg";
import titleCurveIcon from "../../assets/images/reservation-side-curve-cion.svg";
import titleStarIcon from "../../assets/images/reservation-purpole-star-cion.svg";
import coinIcon from "../../assets/images/credit-paln-coins-icon.svg";
import { STORAGE_KEY } from "utils/strings";
import { trackEvent } from "utils/analytics";

const ReservationCancelSuccessScreen: FC = () => {
  const navigate = useNavigate();
  const [reservationData, setReservationData] = useState<any>(null);
  const [showGif, setShowGif] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowGif(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem(
      STORAGE_KEY.RESERVATION_CANCEL_DATA,
    );
    if (storedData) {
      setReservationData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    if (reservationData) {
      trackEvent("reservation_cancelled", {
        slot_id: reservationData?.data?.content?.slot_id ?? null,
        service_type: reservationData?.data?.content?.service_type ?? null,
      });
    }
  }, [reservationData]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="reservation-cancel-success-screen-container">
        <div className="reservation-cancel-success-header-container">
          <div className="title">Cancelled</div>
          <div className="back-container" onClick={handleBackClick}>
            ✕
          </div>
        </div>
        <div className="reservation-cancel-success-screen-content-container">
          {showGif ? (
            <img
              src={allSetAnimation}
              alt="all-set-animation"
              className="animation-container"
            />
          ) : (
            <img
              src={allSetStar}
              alt="all-set-complete"
              className="animation-container"
            />
          )}
          <span className="title">SUCCESSFULLY</span>
          <div className="title-background">
            <img
              src={titleCurveIcon}
              alt="title-curve-icon"
              className="curve"
            />
            <div className="title-container">
              <span>{reservationData?.data?.content?.slot_title}</span>
            </div>
            <img src={titleStarIcon} alt="title-star-icon" className="star" />
          </div>
          <span className="sub-title">Cancelled</span>
          <span className="credit-title">Credits Refunded</span>
          <div className="credit_container">
            <img src={coinIcon} alt="profile-coin-icon" />
            {reservationData?.data?.refund_credits}{" "}
            {reservationData?.data?.refund_credits > 1 ? "Credits" : "Credit"}
          </div>
        </div>
      </div>
      <div
        className="reservation-cancel-success-purchase-btn"
        onClick={handleBackClick}
      >
        Got It
      </div>
    </div>
  );
};

export default ReservationCancelSuccessScreen;
